import { FieldRenderFilters } from '.';
import { getDateValue } from '../../../record-editor/data-event-handler/with-data-events';

export const KEYS = {
  assignedTo: '@assignment',
  title: '4ae3',
  description: '069f',
  taskType: 'e331',
  priority: 'caaa',
  dueDate: '0ed3',
  repeatField: '@repeat',
  location: '7ds7',
  project: '@project',
  status: '@status',
  checkList: 'b835',
  mediaSection: '50c4',
  mediaPhotos: '8125',
  mediaVideos: 'fd0d',
  workNotes: 'b833',
  appLink: 'x758',
  issueLink: 'issue_link',
};

const basicTask = [
  {
    key: KEYS.status,
    changes: [
      {
        attributeName: 'required',
        value: false,
      },
    ],
  },
  {
    key: KEYS.title,
  },
  {
    key: KEYS.description,
    changes: [
      {
        attributeName: 'label',
        value: 'Description',
      },
    ],
  },
  {
    key: KEYS.assignedTo,
  },
  {
    key: KEYS.dueDate,
  },
  {
    key: KEYS.repeatField,
    changes: [
      {
        attributeName: 'shouldRender',
        value: ({ record, fields }: FieldRenderFilters) => getDateValue(fields, record),
      },
    ],
  },
  {
    key: KEYS.taskType,
  },
  {
    key: KEYS.priority,
  },
  {
    key: KEYS.project,
  },
  {
    key: KEYS.mediaSection,
    children: [
      {
        key: KEYS.mediaPhotos,
      },
    ],
  },
  {
    key: KEYS.location,
  },
  {
    key: KEYS.checkList,
  },
  {
    key: KEYS.issueLink,
  },
  {
    key: KEYS.appLink,
  },
  {
    key: KEYS.workNotes,
    changes: [
      {
        attributeName: 'label',
        value: 'Notes',
      },
      {
        attributeName: 'rows',
        value: '3',
      },
    ],
  },
];

export default basicTask;
